import { ChatModel } from '@agent/agent-interface/contact-view/chat/model/chat-model';
import { Injectable } from '@angular/core';
import moment from 'moment';

import { TimerFacade, TimerService } from '@contact/upgrade';

@Injectable({
  providedIn: 'root',
})
export class ChatTimerService {
  private LAST_MESSAGE_TIMER = 'LAST_MESSAGE_TIMER';
  private DURATION_EXCEEDED_COUNTDOWN_TIMER = 'DURATION_EXCEEDED_COUNTDOWN_TIMER';
  private POST_TREATMENT_TIMER = 'POST_TREATMENT_TIMER';
  private POST_TREATMENT_EXCEEDED_TIMER = 'POST_TREATMENT_EXCEEDED_TIMER';

  constructor(private readonly timerService: TimerService, private readonly timerFacade: TimerFacade) {}

  startSlaTimer(chatModel: ChatModel, beginDuration: number = 0): void {
    let timerName = this.getLastMessageTimerName(chatModel.customerId);
    if (chatModel.tab.slaTimer !== -1) {
      this.timerFacade.restart(timerName);
    } else {
      chatModel.tab.slaTimer = 0;
      beginDuration = moment().subtract(moment.duration(beginDuration)).unix();
      this.timerService.startChrono(timerName, { begin: beginDuration }).subscribe(value => (chatModel.tab.slaTimer = value));
    }
  }

  startDurationExceededCountdownTimer(chatModel: ChatModel, duration: number): void {
    let timerName = this.getDurationExceededTimerName(chatModel.customerId);
    if (chatModel.tab.durationExceededCountdownTimer !== -1) {
      this.timerFacade.renew(timerName, duration);
    } else {
      chatModel.tab.durationExceededCountdownTimer = duration;
      this.timerService.startCountdown(timerName, { duration }).subscribe(
        value => (chatModel.tab.durationExceededCountdownTimer = value),
        () => null,
        () => {
          chatModel.tab.durationExceededCountdownTimer = 0;
          this.startSlaTimer(chatModel);
        }
      );
    }
  }

  startTimerForLastMessage(chatModel: ChatModel, beginDuration: number = 0) {
    let timerName = this.getLastMessageTimerName(chatModel.responseId);
    if (chatModel.tab.timerForLastMessage !== -1) {
      this.timerFacade.restart(timerName);
    } else {
      chatModel.tab.timerForLastMessage = 0;
      beginDuration = moment().subtract(moment.duration(beginDuration)).unix();
      this.timerService.startChrono(timerName, { begin: beginDuration }).subscribe(value => (chatModel.tab.timerForLastMessage = value));
    }
  }

  startPostTreatmentTimer(chatModel: ChatModel, beginDuration: number = 0) {
    let timerName = this.getPostTreatmentTimerName(chatModel.responseId);
    if (chatModel.tab.postTreatmentTimerReprieveValue !== -1) {
      this.timerFacade.restart(timerName);
    } else {
      chatModel.tab.postTreatmentTimerReprieveValue = 0;
      this.timerService
        .startChrono(timerName, { begin: beginDuration })
        .subscribe(value => (chatModel.tab.postTreatmentTimerReprieveValue = value));
    }
  }

  startPostTreatmentDurationExceededCountdownTimer(chatModel: ChatModel, duration: number): void {
    let timerName = this.getPostTreatmentExceededTimerName(chatModel.customerId);
    if (chatModel.tab.postTreatmentTimerValue !== -1) {
      this.timerFacade.renew(timerName, duration);
    } else {
      chatModel.tab.postTreatmentTimerValue = duration;
      this.timerService.startCountdown(timerName, { duration }).subscribe(
        value => (chatModel.tab.postTreatmentTimerValue = value),
        () => null,
        () => {
          chatModel.tab.postTreatmentTimerValue = 0;
          this.startPostTreatmentTimer(chatModel);
        }
      );
    }
  }

  stopSlaTimer(chatModel: ChatModel): void {
    chatModel.tab.slaTimer = -1;
    this.timerFacade.stop(this.getLastMessageTimerName(chatModel.customerId));
  }

  stopDurationExceededCountdownTimer(chatModel: ChatModel): void {
    chatModel.tab.durationExceededCountdownTimer = -1;
    this.timerFacade.stop(this.getDurationExceededTimerName(chatModel.customerId));
  }

  stopTimerForLastMessage(chatModel: ChatModel) {
    chatModel.tab.timerForLastMessage = -1;
    this.timerFacade.stop(this.getLastMessageTimerName(chatModel.responseId));
  }

  getSlaTimerValue(chatModel: ChatModel): number {
    return chatModel.tab.slaTimer;
  }

  getDurationExceededCountdownTimer(chatModel: ChatModel): number {
    return chatModel.tab.durationExceededCountdownTimer;
  }

  getTimerForLastMessageValue(chatModel: ChatModel): number {
    return chatModel.tab.timerForLastMessage;
  }

  getPostTreatmentTimerValue(chatModel: ChatModel): number {
    return chatModel.tab.postTreatmentTimerValue;
  }

  getPostTreatmentTimerReprieveValue(chatModel: ChatModel): number {
    return chatModel.tab.postTreatmentTimerReprieveValue;
  }

  private getLastMessageTimerName(customerId: string) {
    return this.LAST_MESSAGE_TIMER + '_' + customerId;
  }

  private getDurationExceededTimerName(customerId: string) {
    return this.DURATION_EXCEEDED_COUNTDOWN_TIMER + '_' + customerId;
  }

  private getPostTreatmentTimerName(customerId: string) {
    return this.POST_TREATMENT_TIMER + '_' + customerId;
  }

  private getPostTreatmentExceededTimerName(customerId: string) {
    return this.POST_TREATMENT_EXCEEDED_TIMER + '_' + customerId;
  }
}
